import { truncate } from 'lodash/string';
import dateFormat, { NUMBER_DATE_TIME_PATTERN } from '../../../procedures/date-format';
import column from '../../abstract/column';
import form from '../../abstract/form';
import vars from '../../abstract/vars';
import actions from './actions';
import api, { modelName } from './api';

export const statusOptions = {
  scheduled: {
    label: 'Zaplanowano',
    color: 'grey',
    value: 'scheduled',
  },
  executing: {
    label: 'W trakcie',
    color: 'blue',
    value: 'executing',
  },
  error: {
    label: 'Błąd',
    color: 'danger',
    value: 'error',
  },
  done: {
    label: 'Wykonane',
    color: 'success',
    value: 'done',
  },
  test: {
    label: 'Test',
    color: 'orange',
    value: 'test',
  },
};


export default {
  actions,
  topRightActions: {},
  modelName,
  api,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    scheduled_at: column({
      label: 'Zaplanowano na',
      form: form({
        required: true,
      }),
    }),
    exchange_name: column({
      label: 'Exchange',
      format: ({ exchange_name }) => truncate(exchange_name),
      form: form({
        required: true,
      }),
    }),
    uid: column({
      label: 'Uid',
    }),
    status_code: column({
      label: 'Status',
      form: form({
        required: true,
      }),
      options: statusOptions,
      component: 'value-status',
    }),
    updated_at: column({
      label: 'Zmiana statusu dnia',
      format: ({ updated_at }) => dateFormat(updated_at, NUMBER_DATE_TIME_PATTERN),
    }),
    reason: column({
      label: 'Powód',
      grid: false,
      format: ({ reason }) => truncate(reason),
    }),

    message: column({
      label: 'Message',
      grid: false,
      form: form({
        required: true,
        transform: ({ value }) => JSON.stringify(value),
        reverseTransform: ({ value }) => JSON.parse(value || '{}'),
        component: 'text',
      }),
    }),
  },
  vars: vars({
    softDelete: {
      title: 'Usunięcie zadania',
      text: ({ id }) => `Czy na pewno chcesz usunąć zaplanowane zadanie o id ${ id }?`,
      successText: 'Zadanie zostało usunięte.',
    },
    noItemsText: 'Brak zadań',
    sidebarLabel: 'Podgląd zadania',
    onSuccessSave: async ({ $router }) => await $router.push({ name: 'system-tasks-index' }),
  }),
};
